export const GroupConfigLabel = ({ full, short }: { full: string; short: string }) => (
  <>
    <span className="sr-only">{full}</span>
    <span aria-hidden="true" className="hidden @[461px]/group-config:inline">
      {full}
    </span>
    <span aria-hidden="true" className="@[461px]/group-config:hidden">
      {short}
    </span>
  </>
);
